import React from 'react'

function Implementos({ funcao, implementos }) {
  return (
    <div className="devices">
        <button onClick={() => funcao(1)}>Voltar</button>
        <h2>Implementos deste dispositivo</h2>
        {implementos.map((implemento) => (
        <div className="devices-preview" key={implemento.implementoID}>
            <h3>Implemento: {implemento.nome}</h3>
            { implemento.sprayerID && (
            <>
                <h3>Pulverizador</h3>
                <p>Largura: {implemento.largura} m</p>
                <p>Transpasse: {implemento.transpasse} m</p>
                <p>Quantidade de seções: {implemento.qtdSecoes}</p>
                <p>Espaçamento entre pontas: {implemento.espacamentoBicos} m</p>
                { implemento.deArrasto === "True" ? (<><p>Implemento de arrasto.</p><p>Chassis: {implemento.chassis} m</p></>) : (<p>Implemento fixo.</p>) }
                <p>Offset traseiro: {implemento.offsetTraseiro} m</p>
                <p>Taxa Desejada: {implemento.taxaDesejada} lts/ha</p>
                <p>{implemento.sensorTipo == 0 ? "Sem Controle de Vazão" : "Controle por sensor de " + (implemento.sensorTipo === 1 ? "fluxo" : "pressão")}</p>
                { implemento.sensorTipo == 1 && <p>Fator calibração fluxômetro: {implemento.fatorFlux > 0 ? implemento.fatorFlux + " pulsos por litro" : "Não calibrado"}</p> }
                { implemento.sensorTipo == 2 && <p>Fator sensor de pressão: {implemento.fatorSensorPressao} %</p> }
                <p>Comando { implemento.comandoTipo == 0 ? "sem" : "com"} retorno calibrado</p>
            </>
            )}
            { implemento.spreaderID && (
            <>
                <h3>Distribuidor</h3>
                <p>Tipo { implemento.model == 0 ? "gravidade" : (implemento.model == 1 ? "arrasto com esteira simples" : "caminhão com esteira simples")}</p>
                <p>Offset traseiro: {implemento.offsetTraseiro} m</p>
                <p>Quantidade de seções: {implemento.qtdSecoes}</p>
                { implemento.model == 1 && <p>Chassis: {implemento.chassis} m</p>}
                { implemento.I > 0 ? <p>Ganhos atuador esteira: P={implemento.P}, I={implemento.I}, ZM={implemento.zonaMorta}</p> : <p>Atuador esteira não calibrado</p> }
                { implemento.I > 0 && <p>Pulsos por volta atuador esteira: {implemento.dentesEsteira}</p> }
                { implemento.I > 0 && <p>Relação de redução atuador esteira: 1:{implemento.reducao}</p> }
                { implemento.I > 0 && <p>Máx. RPM esteira: {implemento.maxRPM} RPM</p> }
                { implemento.IDiscos > 0 ? <p>Ganhos atuador discos: P={implemento.PDiscos}, I={implemento.IDiscos}, ZM={implemento.zonaMortaDiscos}</p> : <p>Atuador discos não calibrado</p> }
                { implemento.IDiscos > 0 && <p>Pulsos por volta atuador discos: {implemento.dentesDiscos}</p> }
                { implemento.IDiscos > 0 && <p>RPM Alvo discos: {implemento.alvoRPMDiscos} RPM</p> }
                { implemento.IDiscos > 0 && <p>Máx. RPM discos: {implemento.maxRPMDiscos} RPM</p> }
                <p>Tempo abertura/fechamento comporta: {implemento.tempoComporta} s</p>
            </> 
            )}
        </div>
        ))}
    </div>
  )
}

export default Implementos